import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { WalletServiceDetailResponse } from '@/repositories/generated';

const htmlContent = `<html>
<body>
<p style='text-align:center'><b>タイトル</b></p>
<p><b>第１章 見出しが入ります。</b></p><br>
テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト<br>
<br>（1）テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト<br>
<br>（2）テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト<br><br>
<p><b>第２章 見出しが入ります。</b></p><br>
テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト<br><br>
<p><b>第３章 見出しが入ります。</b></p><br>
テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト
テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト<br>
<br>（1）テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト<br>
<br>（2）テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト<br><br>
テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト
テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト<br>
<a href="https://policies.google.com/privacy?hl=ja">プライバシーポリシー（サンプル）</a>
</body>
</html>`;

const response: WalletServiceDetailResponse = {
  id: '001',
  name: 'モックWS1',
  mpmUse: true,
  cpmUse: true,
  smartCodeUse: true,
  issuerId: '1',
  issuerName: 'テストイシュア',
  status: 'AVAILABLE',
  walletServiceDetailBasicInfo: {
    chargeMethods: ['STORE', 'BANK_ACCOUNT', 'CREDIT_CARD'],
    cancelValidDays: 100,
    startDate: '2023-04-23',
    paymentMethods: ['PREPAID', 'DIRECT_BANK', 'CREDIT_CARD'],
    endDate: '2023-12-23',
    physicalPrepaidCardUse: true,
  },
  walletServiceDetailChargeAndSettlementInfo: {
    maxChargeAmount: 100000,
    maxChargeAmountPerDay: 1000000,
    maxChargeAmountPerMonth: 5000000,
    maxChargeSettingUnit: 1000,
    maxSettlementAmount: 100000,
    maxSettlementAmountPerDay: 500000,
    maxSettlementAmountPerMonth: 1000000,
    maxSettlementSettingUnit: 1000,
    counterChargeUnit: 100,
    directBankChargeUnit: 100,
    creditCardChargeUnit: 1000,
    minCounterChargeAmount: 1000,
    minDirectBankChargeAmount: 1000,
    minCreditCardChargeAmount: 1000,
  },
  walletServiceDetailValueAndPointInfo: {
    valueUnit: '円',
    pointUnit: 'pt',
    prepaidValueName: '〇〇マネーライト',
    fundsTransferValueName: '〇〇マネー',
    bonusValueName: 'ボーナスマネー',
    basicPointName: '〇〇ポイント',
    bonusPointName: 'スペシャルポイント',
    maxPrepaidValueBalance: 1000000,
    maxTransferValueBalance: 1000000,
    maxBonusValueBalance: 1000000,
    maxBasicPointBalance: 1000000,
    maxBonusPointBalance: 1000000,
    prepaidValueExpirationPeriod: '取引日から36ヶ月後の月末',
    bonusValueExpirationPeriod: '最終チャージ/付与日から36ヶ月後の月末',
    pointRatio: 0.5,
    pointUse: 'FORCED_USE',
    pointUseUnit: 100,
    expirationNoticePeriod: ['15', '10'],
  },
  walletServiceDetailApplicationInfo: {
    iosAppVersion: '1.0.0',
    androidAppVersion: '1.0.0',
    walletUserPasswordAttempts: 4,
    walletUserPasswordUnLockMinute: 60,
    latestTermsDocument: {
      version: '1.01',
      prescribedDate: '2022-01-01',
      body: htmlContent,
    },
    walletUserSignUpMethods: ['PHONE', 'EMAIL', 'TEMP_PASSWORD', 'JWT'],
    creditCardGwConnectionDestination: 'GMO_PAYMENT_GATEWAY',
    privacyPolicy: {
      version: '2.03',
      prescribedDate: '2021-01-01',
      body: htmlContent,
    },
    walletUserLoginMethods: ['PHONE', 'EMAIL', 'PASSWORD', 'JWT'],
    bankAccountPaymentPWAuth: true,
    faqUrl: 'http://www.example.com/faq',
    loginIdType: 'MAIL',
    tokenForBankAccountRegisterExpiration: 1800,
    contactUrl: 'http://www.example.com/inquiry',
    displayName: true,
    displayNameKana: true,
    displayBirthday: true,
    displayGender: true,
    ekycNegaCheckFlag: '0',
    bankPayNegaCheckFlag: '1',
    brandPrepaidNegaCheckFlag: '2',
    housePrepaidNegaCheckFlag: '3',
    reregisterRefusalPeriod: 4,
    codeRetryExpiresFor: 5,
    codeExpiresAt: 6,
    ekycCheckFlag: '7',
    balanceReferenceFlag: '8',
    nfcStatusReferenceFlag: '9',
    passwordRetryExpiresFor: 10,
    loginLockExpiresAt: 11,
    brandPrepaidApplyFlag: '12',
    housePrepaidApplyFlag: '13',
  },
  remarks: '備考',
};

export const walletServiceDetail = http.get(
  createMockEndpoint('/wallet_service/:id'),
  async ({ params }) => {
    if (params.id === '002') {
      const nullResponse: WalletServiceDetailResponse = {
        ...response,
        ...{
          walletServiceDetailApplicationInfo: {
            walletUserPasswordAttempts: 4,
            walletUserPasswordUnLockMinute: 60,
            latestTermsDocument: {},
            walletUserSignUpMethods: ['PHONE', 'EMAIL', 'TEMP_PASSWORD', 'JWT'],
            privacyPolicy: {},
            walletUserLoginMethods: ['PHONE', 'EMAIL', 'PASSWORD', 'JWT'],

            reregisterRefusalPeriod: 0,
            codeRetryExpiresFor: 0,
            codeExpiresAt: 0,
            passwordRetryExpiresFor: 0,
            loginLockExpiresAt: 0,

          },
        },
      };

      return HttpResponse.json(nullResponse, { status: 200 });
    }
    await delay(500);

    return HttpResponse.json(response, { status: 200 });
  },
);
